import { Icon } from '@iconify/react'
import { formatArea, formatRelative } from '../utils/events'

const StatCard = ({ icon, label, value, hint }) => (
    <div className="stat-card">
        <Icon icon={icon} className="stat-card__icon" aria-hidden="true" />
        <div className="stat-card__body">
            <span className="stat-card__value">{value}</span>
            <span className="stat-card__label">{label}</span>
            {hint && <span className="stat-card__hint">{hint}</span>}
        </div>
    </div>
)

const StatsBar = ({ stats, totalCount }) => {
    const filtered = stats.count !== totalCount

    return (
        <section className="stats-bar" aria-label="Statistiques">
            <StatCard
                icon="mdi:fire"
                label="Feux affichés"
                value={stats.count}
                hint={filtered ? `sur ${totalCount} au total` : undefined}
            />
            <StatCard
                icon="mdi:earth"
                label="Régions touchées"
                value={stats.regions}
            />
            <StatCard
                icon="mdi:texture-box"
                label="Surface cumulée"
                value={formatArea(stats.totalHectares)}
                hint={`${stats.withArea} feu${stats.withArea > 1 ? 'x' : ''} mesuré${stats.withArea > 1 ? 's' : ''}`}
            />
            <StatCard
                icon="mdi:clock-alert-outline"
                label="Détection la plus récente"
                value={stats.latest ? formatRelative(stats.latest.timestamp) : '—'}
                hint={stats.latest?.regionLabel}
            />
        </section>
    )
}

export default StatsBar
